<ng-container *ngIf="!group._destroy">
  <ion-item class="clickable" (dblclick)="toggleExpand($event)" #currentItem
    (click)="select(currentItem, group, $event)">
    <span slot="start">
      <mits-icon [name]="icon"></mits-icon>
    </span>
    <span>{{ displayTitle }}</span>
    <span slot="end" class="actionButtons clickable" (click)="toggleExpand($event)">
      <mits-icon *ngIf="!expanded" name="chevron-down"></mits-icon>
      <mits-icon *ngIf="expanded" name="chevron-up"></mits-icon>
    </span>
  </ion-item>
  <ion-list [ngClass]="{'expanded': expanded}">
    <ch-module *ngFor="let module of group?.modules" [module]="module"
      (selected)="select($event.htmlElement, $event.item, $event.clickEvent)"></ch-module>
  </ion-list>
</ng-container>